<template>
  <div>
    <b-row>
      <b-col sm="6" md="8">
        <b-row>
          <b-col>
            <type-component
              :organization="organization"
              v-model="type"
            ></type-component>
          </b-col>
          <b-col class="col-auto text-right pt-1">
            <a href="#" @click.prevent="show_advanced = !show_advanced">
              {{ trans('advanced_options') }}
              <i v-if="!show_advanced" class="fa fa-fw fa-plus"></i>
              <i v-if="show_advanced" class="fa fa-fw fa-minus"></i>
            </a>
          </b-col>
        </b-row>

        <from-component
          v-show="show_advanced"
          :organization="organization"
          :type="type"
          v-model="from_email"
          :from-name="from_name"
        ></from-component>

        <reply-to-component
          v-show="show_advanced"
          :organization="organization"
          :user="user"
          :type="type"
          v-model="reply_to"
        ></reply-to-component>

        <comtype-component v-model="comtype"></comtype-component>

        <to-component
          v-if="!to_custom"
          :organization="organization"
          :user="user"
          :recipient_lists="recipient_lists"
          :type="type"
          :comtype="comtype"
          :resend_not_opened_count="resend_not_opened_count"
          v-model="to"
          :cc_user_ids="cc_user_ids"
          :show_cc="show_cc"
          :show-combine-list="showCombineList"
          :show-class-participants-list="showClassParticipantsList"
          @show-cc="onClickCC"
        ></to-component>

        <b-row v-if="showMessageBothParents || showAllowDups">
          <b-col v-if="showMessageBothParents">
            <b-form-group class="mt-2 mb-3">
              <b-form-checkbox v-model="message_both_parents" :disabled="isSaving">
                {{ trans('message_both_parents') }}
                <small class="text-muted" :title="trans('message_both_parents_about')" v-b-tooltip.hover>
                  <i class="fa fa-fw fa-info-circle"></i>
                </small>
              </b-form-checkbox>
            </b-form-group>
          </b-col>
          <b-col v-if="showAllowDups">
            <b-form-group class="mt-2 mb-3">
              <b-form-checkbox v-model="allow_dups" :disabled="isSaving">
                {{ trans('allow_sending_duplicates') }}
                <small class="text-muted" :title="trans('allow_sending_duplicates_about')" v-b-tooltip.hover>
                  <i class="fa fa-fw fa-info-circle"></i>
                </small>
              </b-form-checkbox>
            </b-form-group>

          </b-col>
        </b-row>

        <cc-component v-if="show_cc"
          :organization="organization"
          v-model="cc_user_ids"
          :show-email="type == 'both' || type == 'email'"
          :show-mobile="type == 'both' || type == 'sms'"
          :disabled="isSaving"
        ></cc-component>

        <subject-component
          :organization="organization"
          :type="type"
          v-model="subject"
        ></subject-component>

        <body-component
          ref="body"
          :organization="organization"
          v-model="body"
          :type="type"
          :template_id="template_id"
          :initial_message_sample_id="initial_message_sample_id"
          @ready="prefillInitialBody"
        ></body-component>

        <b-alert
          v-if="showSmsWarnings"
          variant="warning"
          class="small mt-2"
          show
        >
          <i class="fas fa-exclamation-triangle mr-1"></i>
          <strong>{{ trans('sms_composition_warning') }}</strong>
          <ul class="mb-0 pl-3">
            <li v-if="messageCost > 1" v-html="trans('multi_segment_warning', {count: messageCost})"></li>
            <li v-if="hasEmojis">{{ trans('emoji_warning') }}</li>
            <li v-if="messageCost > 1 && !containsUnicode">{{ trans('sms_general_info') }}</li>
            <li v-if="containsUnicode">{{ trans('unicode_warning') }}</li>
            <li v-if="hasLinksInSmsWithoutTemplate">{{ trans('txt_has_links') }}</li>
          </ul>
        </b-alert>

        <b-row>
          <b-col>
            <b-dropdown
              v-if="!ucid"
              :text="trans('attachment')"
              variant="link"
              class="mb-2"
              toggle-class="p-0"
            >
              <b-dropdown-item @click="use_form = !use_form; if (use_form) use_shorten_url = use_video_url = use_media_url = use_paper = false">
                <i :class="'fa fa-fw ' + (use_form ? 'fa-check' : '')"></i>
                <i class="fa fa-fa fa-file-alt text-muted"></i>
                {{ trans('attach_form') }}
              </b-dropdown-item>
              <b-dropdown-item @click="use_shorten_url = !use_shorten_url; if (use_shorten_url) use_video_url = use_media_url = use_form = use_paper = false">
                <i :class="'fa fa-fw ' + (use_shorten_url ? 'fa-check' : '')"></i>
                <i class="fa fa-fa fa-link text-muted"></i>
                {{ trans('attach_a_url') }}
              </b-dropdown-item>
              <b-dropdown-item @click="use_video_url = !use_video_url; if (use_video_url) use_shorten_url = use_media_url = use_form = use_paper = use_template = false">
                <i :class="'fa fa-fw ' + (use_video_url ? 'fa-check' : '')"></i>
                <i class="fa fa-fw fa-video text-muted"></i>
                {{ trans('attach_video_url') }}
              </b-dropdown-item>
              <b-dropdown-item @click="use_media_url = !use_media_url; if (use_media_url) use_shorten_url = use_video_url = use_form = use_paper = use_template = false">
                <i :class="'fa fa-fw ' + (use_media_url ? 'fa-check' : '')"></i>
                <i class="fa fa-fw fa-image text-muted"></i>
                {{ trans('attach_media_url') }}
              </b-dropdown-item>
              <b-dropdown-item @click="use_paper = !use_paper; if (use_paper) use_shorten_url = use_video_url = use_form = use_media_url = use_template = false">
                <i :class="'fa fa-fw ' + (use_paper ? 'fa-check' : '')"></i>
                <i class="fa fa-fw fa-certificate text-muted"></i>
                {{ trans('attach_paper_url') }}
              </b-dropdown-item>
            </b-dropdown>
            <b-form-group v-if="!!ucid && !invoice_is_contract">
              <b-form-checkbox v-model="use_shorten_url">
                <span v-if="!recipient_list_id">
                  <i class="fa fa-fw fa-shopping-cart"></i>
                  {{ trans('send_shopping_cart') }}
                </span>
                <span v-if="!!recipient_list_id">
                  <i class="fa fa-fw fa-file-invoice-dollar"></i>
                  {{ trans('send_prefilled_form') }}
                </span>
              </b-form-checkbox>
            </b-form-group>
          </b-col>
          <b-col class="col-auto">
            <b-button
              variant="link"
              class="p-0"
              @click="onClickUseTemplate"
            >
              {{ trans('use_template') }}
              <i :class="`fa fa-fw fa-${use_template ? 'minus' : 'plus'}`"></i>
            </b-button>
          </b-col>
        </b-row>

        <b-form-group v-if="use_template">
          <label>
            <i class="fa fa-fw fa-file-alt"></i>
            {{ trans('sending_template') }}
          </label>
          <b-row>
            <b-col>
              <template-dropdown
                ref="template"
                v-model="template_id"
                :organization="organization"
                :disabled="templates_busy"
                nullable
                @input="onChangeTemplate(false)"
                @loaded="onChangeTemplate(true)"
              ></template-dropdown>
            </b-col>
            <b-col class="col-auto pl-0">
              <b-button
                v-if="!hide_oto_template"
                :variant="edit_oto_template ? 'primary' : 'outline-primary'"
                class="ml-2"
                @click="onToggleOtoTemplate"
                :disabled="templates_busy"
              >
                {{ trans(edit_oto_template ? 'oto_hide' : 'edit') }}
                <small v-if="!edit_oto_template" :title="trans('oto_template_about')" v-b-tooltip.hover>
                  <i class="fa fa-fw fa-info-circle"></i>
                </small>
              </b-button>
              <b-button
                v-if="hide_oto_template"
                variant="outline-primary"
                class="ml-2"
                :href="`/organization/${organization.id}/template/${template_id}`"
                target="_blank"
                :disabled="templates_busy"
              >
                {{ trans('modify') }}
                <i class="fa fa-fw fa-external-link-alt"></i>
              </b-button>
            </b-col>
          </b-row>
        </b-form-group>

        <b-form-group v-if="false && use_template && !edit_oto_template && (type.indexOf('sms') >= 0 || type == 'both')">
          <label class="d-block">
            {{ trans('inlcude_image_in_sms') }}
          </label>
          <a href="#"
            @click.prevent="template_image_url = null"
            :class="'template-image blank m-2' + (template_image_url == null ? ' active' : '')">
            <b-img thumbnail />
            <span>{{ trans('none') }}</span>
          </a>
          <a
            v-for="image_url in template_image_urls"
            v-bind:key="image_url"
            href="#"
            @click.prevent="template_image_url = image_url"
            :class="'template-image m-2' + (template_image_url == image_url ? ' active' : '')"
          >
            <b-img thumbnail :src="image_url" />
          </a>
        </b-form-group>

        <b-form-group v-if="use_shorten_url && !ucid" class="m-2">
          <url-input
            :organization="organization"
            v-model="shorten_url"
            @cancel="use_shorten_url=false"
            @document="onDocument"
            @page="onPage"
          />
        </b-form-group>

        <div v-if="use_form" class="m-2">
          <b-form-group>
            <b-row>
              <b-col>
                <label>{{ trans('attach_form') }}</label>
              </b-col>
              <b-col class="col-auto text-right">
                <a href="#" class="text-danger" @click.prevent="use_form = false">
                  <i class="fa fa-fw fa-times"></i>
                </a>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <form-dropdown
                  :organization="organization"
                  v-model="recipient_form_id"
                  :placeholder="trans('choose_a_form')"
                  mode="forms"
                  @list="onRecipientForm"
                  :disabled="!allow_form_override && (!!initial_recipient_filter || recipient_form_send_not_signed)"
                />
              </b-col>
            </b-row>
          </b-form-group>
          <b-form-group>
            <b-form-checkbox
              v-if="!recipient_form_send_not_signed"
              v-model="only_send_not_filled"
              :disabled="!allow_form_override && (!!initial_recipient_filter || recipient_form_send_not_signed)"
            >
              {{ only_send_not_filled_label }}
              <small class="text-muted" :title="trans('known_at_send_because_filter')" v-b-tooltip.hover>
                <i class="fa fa-fw fa-info-circle"></i>
              </small>
            </b-form-checkbox>
          </b-form-group>
        </div>

        <b-form-group v-if="use_shorten_url || use_form" class="mx-2">
          <label>
            {{ trans('button_text') }}
            <small class="text-muted" :title="trans('leave_blank_for_link')" v-b-tooltip.hover>
              <i class="fa fa-fw fa-info-circle"></i>
            </small>
          </label>
          <b-form-input v-model="shorten_button_text" :placholder="trans('button_text')" />
        </b-form-group>


        <b-form-group v-if="use_video_url" class="m-2">
          <video-input
            :organization="organization"
            v-model="video_url"
            :gated="video_gated"
            :gated_vimeo_url="gated_vimeo_url"
            @busy="video_thumbnail_busy = $event"
            @thumbnail="video_thumbnail_url = $event"
            @name="updateSubject($event)"
            @close="use_video_url = false"
            @gated="video_gated = $event"
          >
          </video-input>
        </b-form-group>

        <b-form-group v-if="use_media_url" class="m-2">
          <image-input
            :organization="organization"
            v-model="media_url"
            @close="use_media_url = false"
          >
          </image-input>
        </b-form-group>

        <b-form-group v-if="use_paper" class="m-2">
          <papers-dropdown
            :organization="organization"
            v-model="paper_id"
            nullable
            @paper="paper = $event"
          ></papers-dropdown>
        </b-form-group>

        <b-form-group v-if="invoice_no || canAttachPdfInvoice" class="my-2">
          <b-form-checkbox v-model="attach_invoice">
            {{ trans('attach_invoice_pdf') }}
            <br/>
            <b-link :href="!invoice_no ? '#' : `/organization/${organization.id}/invoice/no/${invoice_no}/pdf`" target="_blank">
              <i class="fa fa-file-pdf"></i>
              {{ trans('invoice') }}.pdf
            </b-link>
          </b-form-checkbox>
        </b-form-group>

        <b-form-group v-if="!invoice_no && !canAttachPdfInvoice && !!canAttachPdfRecipientList" class="my-2">
          <b-form-checkbox v-model="attach_pdf_recipient_list_id" :value="canAttachPdfRecipientList.id" :unchecked-value="null">
            {{ trans('attach_form_pdf') }}
            <br/>
            <b-link href="#" target="_blank" @click.prevent>
              <i class="fa fa-file-pdf"></i>
              {{ trans(canAttachPdfRecipientList.is_evaluation_form ? 'evaluation' : 'form') }}.pdf
            </b-link>
          </b-form-checkbox>
        </b-form-group>
        <b-form-group v-if="canAttachPdfTickets" class="my-2">
          <b-form-checkbox v-model="attach_pdf_tickets">
            {{ trans('attach_pdf_tickets') }}
            <small class="text-muted" :title="trans('attach_tickets_info')" v-b-tooltip.hover>
              <i class="fa fa-fw fa-info-circle"></i>
            </small>
            <br/>
            <b-link href="#" target="_blank" @click.prevent>
              <i class="fa fa-file-pdf"></i>
              {{ trans('Tickets') }}.pdf
            </b-link>
          </b-form-checkbox>
        </b-form-group>

        <cc-component
          v-if="showBottomCc"
          :organization="organization"
          v-model="cc_user_ids"
          :show-email="type == 'both' || type == 'email'"
          :show-mobile="type == 'both' || type == 'sms'"
          :disabled="isSaving"
        ></cc-component>

        <b-card-text class="mt-2">
          <em :class="{ 'text-danger': isError}">
            <i class="fa fa-fw fa-spin fa-circle-notch" v-if="isSaving"></i>
            {{ status }}
          </em>
          <span v-if="!status && !hasErrors && !doNotForgetMessage">&nbsp;</span>
          <span class="text-danger" v-if="hasErrors">{{ validationErrors.join(' ') }}</span>
          <span v-if="!status && !hasErrors && doNotForgetMessage" class="text-danger">
            😉 {{ doNotForgetMessage }}
          </span>
          <span v-if="!status && !hasErrors && sendingManySmsMessage" class="text-danger">
            😮 {{ sendingManySmsMessage }}
          </span>
          <span v-if="!status && !hasErrors && emptyListWarning" class="text-danger">
            {{ emptyListWarning }}
          </span>
        </b-card-text>

        <b-row class="mt-2" v-if="!edit_oto_template">
          <b-col>
            <b-button
              v-if="!hide_submit_button"
              variant="primary"
              @click="onClickSubmit"
              class="mr-2"
              :disabled="isSaving||hasErrors"
            >
              {{ trans('send') }}
            </b-button>
            <b-button
              v-if="!hide_cancel_button"
              variant="outline-secondary"
              @click="onClickCancel"
            >
              {{ trans('cancel') }}
            </b-button>
          </b-col>
          <b-col v-if="!hideScheduling" class="col-auto">
            <b-button variant="primary" v-b-modal.schedule-sendout :disabled="isSaving||hasErrors">
              <i class="fa fa-fw fa-clock"></i>
              {{ trans('schedule_action') }}
            </b-button>
            <schedule-modal
              :organization="organization"
              :user="user"
              :send_out="serialized"
              :to="to"
              @scheduled="$emit('scheduled', $event)"
            ></schedule-modal>
          </b-col>
          <b-col v-if="!hideScheduling" class="col-auto pl-0">
            <b-button variant="outline-primary" @click="onClickPreview" :disabled="!canClickPreview">
              {{ trans('preview') }}
            </b-button>
            <message-preview-modal
              :organization="organization"
              :send-out="serialized"
              :preset-preview-url="emailPreviewUrl"
            ></message-preview-modal>
          </b-col>
          <b-col class="col-auto text-right">
            <count-component
              :organization="organization"
              :type="type"
              :sms_count="smsCount"
              :email_count="emailCount"
              :known-at-send-because-filter="!!recipient_filter || message_both_parents"
            ></count-component>
          </b-col>
        </b-row>
      </b-col>

      <b-col sm="6" md="4" style="overflow: hidden;">
        <div id="preview" ref="preview">
          <div id="sms_preview" v-if="preview == 'sms'">
            <img class="iphone-12" src="/img/frontend/iphone-12-message.png" />
            <div
              class="chat"
              ref="chat"
              :style="`
                margin-top: ${emailPreviewMarginY}px;
                margin-left: ${emailPreviewMarginX}px;
                -ms-transform: scale(${emailPreviewScale});
                -moz-transform: scale(${emailPreviewScale});
                -o-transform: scale(${emailPreviewScale});
                -webkit-transform: scale(${emailPreviewScale});
                transform: scale(${emailPreviewScale});
                -ms-transform-origin: 0 0;
                -moz-transform-origin: 0 0;
                -o-transform-origin: 0 0;
                -webkit-transform-origin: 0 0;
                transform-origin: 0 0;`"
            >
              <div
                v-for="(g, gi) in groupedMessages"
                :key="gi"
                :class="`messages ${g.source}`"
              >
                <small v-if="!!g.when" class="d-block w-100 text-muted text-center">{{ g.when }}</small>
                <div
                  v-for="(m, mi) in g.messages"
                  :key="m.id"
                  :class="`message ${mi == g.messages.length-1 ? 'last' : ''}`"
                  v-html="m.body"
                ></div>
              </div>
              <div class="yours messages">
                <div class="message last" v-html="message"></div>
              </div>
            </div>
          </div>
          <div id="email_preview" v-if="preview == 'email'">
            <img class="iphone-12" src="/img/frontend/iphone-12-email.png" style="z-index:200;pointer-events:none;" />
            <p v-if="emailPreviewBusy && emailPreviewEmpty" class="text-center" style="position:absolute; margin-top:150px; left:0; right:0;">
              <small>
                <i class="fa fa-fw fa-circle-notch fa-spin"></i>
                {{ trans('please_wait') }}
              </small>
            </p>
            <p v-if="emailPreviewError" class="text-danger text-center" style="position:absolute; margin-top:150px; left:0; right:0;">
              <small>
                {{ emailPreviewError }}
              </small>
            </p>
            <iframe
              ref="iframe"
              v-if="emailPreviewUrl"
              frameborder="0"
              :width="360"
              :height="540"
              :src="emailPreviewUrl"
              :style="`
                position: absolute;
                z-index: 100;
                margin-top: ${emailPreviewMarginY}px;
                margin-left: ${emailPreviewMarginX}px;
                -ms-transform: scale(${emailPreviewScale});
                -moz-transform: scale(${emailPreviewScale});
                -o-transform: scale(${emailPreviewScale});
                -webkit-transform: scale(${emailPreviewScale});
                transform: scale(${emailPreviewScale});
                -ms-transform-origin: 0 0;
                -moz-transform-origin: 0 0;
                -o-transform-origin: 0 0;
                -webkit-transform-origin: 0 0;
                transform-origin: 0 0;`"
              @load="onIframeLoaded"
            />
          </div>
        </div>
      </b-col>
    </b-row>

    <div v-if="edit_oto_template && oto_template != null" id="template-oto">
      <p>{{ trans('oto_template_about') }}</p>
      <template-component
        :organization="organization"
        :template="oto_template"
        :can_choose_list="false"
        :show_test_placeholders="!!templateInitialRecipient || !!templateInitialListId"
        :initial_recipient="templateInitialRecipient"
        :initial_list_id="templateInitialListId"
        class="mt-2"
        @saved="maybeRefreshEmailPreview(true)"
      >
      </template-component>
    </div>
  </div>
</template>

<style>
#send-out-ckeditor-wrapper.short .ck-content {
    min-height: 50px;
}
#send-out-ckeditor-wrapper.short .ck-editor__editable {
    max-height: 70px;
}
</style>

<script>
  import ComtypeComponent from './ComtypeComponent'
  import TypeComponent from './SendOutTypeComponent'
  import FromComponent from './SendOutFromComponent'
  import ToComponent from './ToComponent'
  import CcComponent from './SendOutCcComponent'
  import ReplyToComponent from './SendOutReplyToComponent'
  import SubjectComponent from './SubjectComponent'
  import BodyComponent from './BodyComponent'
  import CountComponent from './SendOutCountComponent'
  import ScheduleModal from './SendOutScheduleModal'
  import TemplateDropdown from './../template/TemplateDropdown'
  import TemplateComponent from './../template/TemplateComponent'
  import VideoInput from './SendOutVideoComponent'
  import ImageInput from './SendOutImageComponent'
  import UrlInput from './SendOutUrlComponent'
  import FormDropdown from './../list/ListDropdown'
  import MessagePreviewModal from './MessagePreviewModal'
  import PapersDropdown from './../paper/PapersDropdown'


  export default {
    components: {
      ComtypeComponent,
      TypeComponent,
      FromComponent,
      ToComponent,
      CcComponent,
      ReplyToComponent,
      SubjectComponent,
      BodyComponent,
      CountComponent,
      ScheduleModal,
      TemplateDropdown,
      TemplateComponent,
      VideoInput,
      ImageInput,
      UrlInput,
      FormDropdown,
      MessagePreviewModal,
      PapersDropdown,
    },
    props: {
      organization: Object,
      user: Object,
      rl24: Object,
      recipient_lists: {
        type: Array,
        default() {return []},
      },
      recipient_list_id: Number,
      amilia_event_id: Number,
      booking_id: Number,
      send_out: Object,
      initial_from_email: String,
      initial_from_name: String,
      initial_reply_to_email: String,
      reply_to_user: {
        type: Boolean,
        default: false,
      },
      initial_type: {
        type: String,
        default: 'both',
        validator(value) {
          return ['sms', 'email', 'both'].indexOf(value) !== -1
        },
      },
      initial_paper_id: Number,
      initial_template_id: Number,
      initial_subject: String,
      initial_body: String,
      initial_message_sample_id: String,
      initial_use: String,
      initial_use_url: String,
      initial_use_url_cta: String,
      initial_video_thumbnail_url: String,
      initial_video_gated: Boolean,
      gated_vimeo_url: Object,
      initial_recipient_form_id: Number,
      share_qr_code: Boolean,
      recipient_form_send_not_signed: {
        type: Boolean,
        default: false
      },
      initial_recipient_filter: Object,
      allow_form_override: {
        type: Boolean,
        default: false,
      },
      invoice_no: Number,
      initial_attach_invoice: Boolean,
      canAttachPdfInvoice: Boolean,
      invoice_is_contract: Boolean,
      ucid: String,
      person_mobile: String,
      person_email: String,
      person_name: String,
      people: Array,
      to_self: Boolean,
      return_url: String,
      automation_id: Number,
      automation_meta: Object,
      initial_comtype: String,
      to_custom: Object, // sms_count, email_count
      hide_submit_button: Boolean,
      hide_cancel_button: Boolean,
      hideScheduling: {
        type: Boolean,
        default: false,
      },
      hide_oto_template: Boolean,
      initial_cc_user_ids: Array,
      initial_message_both_parents: Boolean,
      showBottomCc: {
        type: Boolean,
        default: false,
      },
      is_referral: {
        type: Boolean,
        default: false,
      },
      noRedirect: {
        type: Boolean,
        default: false,
      },
      showCombineList: {
        type: Boolean,
        default: false,
      },
      showClassParticipantsList: {
        type: Boolean,
        default: false,
      },
      subset_of_recipient_list_id: Number,
      context: Object,
      canAttachPdfRecipientList: Object,
      canAttachPdfTickets: {
        type: Boolean,
        default: false
      },
      attachPdf: {
        type: Boolean,
        default: false,
      },
      hideMessageBothParents: {
        type: Boolean,
        default: false,
      },
      allowDups: Boolean,
      forceLang: {
        type: String,
        default: null
      },
      thread_twilio_message_id: Number,
    },
    data() {
      let subject = this.initial_subject || trans('message_from').replace(':org', this.organization.name)
      let body = this.initial_body || `<p>${this.organization.alias}</p>`

      let from_email = this.initial_from_email || this.organization.from_email
      if ((this.organization.verified_from_emails||[]).indexOf(from_email) === -1)
        from_email = this.organization.from_email

      let type = this.initial_type || (
          (!this.person_mobile && !this.person_email) ?
            this.organization.default_send_type :
            (this.person_email && !this.person_mobile ? 'email' :
            (this.person_mobile && !this.person_email ? 'sms' : this.organization.default_send_type))
      )

      return {
        options: _.cloneDeep(this.send_out),
        trans: trans,
        numeral: numeral,
        status: null,
        isError: false,
        isSaving: false,
        show_advanced: false,
        from_email: from_email,
        from_name: this.initial_from_name,
        reply_to: {
          mobile_preference: (() => {
            // It is possible mobile numbers are not set. Adjust the
            // reply preference accordingly.
            let pref = this.reply_to_user ? 'forward_sender' : this.organization.reply_to_mobile_preference
            if (pref == 'forward_organization' && !this.organization.reply_to_mobile) pref = 'do_nothing'
            if (pref == 'forward_sender' && !(this.user.mobile && this.user.mobile_confirmed)) pref = 'do_nothing'
            return pref
          })(),
          mobile: (() => {
            let pref = this.reply_to_user ? 'forward_sender' : this.organization.reply_to_mobile_preference
            if (pref == 'forward_organization' && this.organization.reply_to_mobile) return this.organization.reply_to_mobile
            if (pref == 'forward_sender' && this.user.mobile && this.user.mobile_confirmed) return this.user.mobile
            return null
          })(),
          email: (() => {
            let reply_to_email = this.initial_reply_to_email ?
              this.initial_reply_to_email :
              (this.organization.reply_to_email ?
                this.organization.reply_to_email :
                this.user.email)
            return this.reply_to_user ? this.user.email : reply_to_email
          })(),
        },
        sms_price: parseFloat(this.organization.sms_price, 10),
        email_price: parseFloat(this.organization.email_price, 10),
        type: type,
        to: {
          to: this.people || this.person_mobile || this.person_email ? 'people' : (this.to_self ? 'self' : 'list'),
          list_id: this.recipient_list_id,
          amilia_list: null,
          combine_list: null,
          class_participants_list: null,
          csv_activity: this.initial_recipient_filter ? this.initial_recipient_filter.csv_activity : null,
          form_custom_value: this.initial_recipient_filter ? this.initial_recipient_filter.form_custom_value : null,
          to_mobile: this.person_mobile,
          to_email: this.person_email,
          people: this.people || _.compact([
            this.person_mobile || this.person_email ? {
              name: this.person_name || null,
              email: this.person_email || null,
              mobile: this.person_mobile || null,
            } : null,
          ]),
        },
        show_cc: false,
        cc_user_ids: this.initial_cc_user_ids ?
          this.initial_cc_user_ids :
          (!!this.template_id ? [this.user.id] : []),
        message_both_parents: this.initial_message_both_parents ? this.initial_message_both_parents : false,
        subject: subject,
        body: body,
        use_shorten_url: this.initial_use == 'shorten_url',
        shorten_url: this.initial_use == 'shorten_url' ? (this.initial_use_url || null) : null,
        document: null,
        shorten_button_text: this.initial_use_url_cta || null,
        use_video_url: this.initial_use == 'video',
        video_url: this.initial_use == 'video' ? (this.initial_use_url || null) : null,
        video_thumbnail_url: this.initial_use == 'video' ? (this.initial_video_thumbnail_url || null) : null,
        video_thumbnail_busy: false,
        video_gated: this.initial_video_gated || false,
        use_media_url: this.initial_use == 'media', // really an image
        media_url: this.initial_use == 'media' ? (this.initial_use_url || null) : null,
        use_paper: !!this.initial_paper_id,
        paper_id: this.initial_paper_id || null,
        paper: null,
        use_template: !!this.initial_template_id,
        use_form: this.initial_use == 'form',
        templates_busy: false,
        template_id: this.initial_template_id || null,
        template_image_cache: {},
        template_image_urls: [],
        template_image_url: null,
        recipient_form_id: this.initial_recipient_form_id || null,
        recipient_form: null,
        only_send_not_filled: this.initial_recipient_filter && this.initial_recipient_filter.type == 'filled' ? true : false,
        attach_invoice: this.initial_attach_invoice || false,
        edit_oto_template: false, // one-time-only
        oto_template_id: null,
        oto_templates: [],
        comtype: this.initial_comtype || this.organization.default_comtype,
        allow_dups: this.allowDups || false,
        force_lang: this.forceLang || null,
        _hasErrors: true, // previous value used to trigger an event
        preview: type != 'both' ? type : 'email', // sms or email
        emailPreviewUrl: null,
        emailPreviewFullWidth: null,
        emailPreviewBusy: false,
        emailPreviewError: null,
        emailPreviewEmpty: true,
        emailPreviewLastOptions: null,
        emailPreviewLoadWhenIdle: false,
        attach_pdf_recipient_list_id: this.canAttachPdfRecipientList && this.attachPdf ? this.canAttachPdfRecipientList.id : null,
        attach_pdf_tickets: this.canAttachPdfTickets && this.attachPdf && this.attach_pdf_recipient_list_id != null ? true : false,
        last_selected_template_id: null,
        thread_messages: null,
      }
    },
    computed: {
      hasEmojis() {
        if (!this.body || (this.type !== 'both' && this.type !== 'sms')) {
          return false
        }

        return _.containsEmoji(this.body);
      },
      showSmsWarnings() {
        return this.type !== 'email' &&
          (this.hasEmojis || this.messageCost > 1 || this.containsUnicode || this.hasLinksInSmsWithoutTemplate);
      },
      containsUnicode() {
        return !_.isGsm7(this.body)
      },
      messageCost() {
        const segmentSize = this.containsUnicode ? 70 : 160;
        return Math.ceil(this.characterCount / segmentSize);
      },
      characterCount() {
        return _.ckeditorHtmlToText(this.body).length
      },
      hasLinksInSmsWithoutTemplate() {
        return !this.use_template &&
          (this.type == 'sms' || this.type == 'both') &&
          !!this.body &&
          (this.body.indexOf('http://') >= 0 || this.body.indexOf('https://') >= 0 )
      },
      resend_not_opened_count() {
        return this.initial_recipient_filter && this.initial_recipient_filter.type == 'not_opened' ? this.initial_recipient_filter.count : null
      },
      showMessageBothParents() {
        if (this.hideMessageBothParents) return false
        if (this.automation_meta &&
          ['amilia_activity_reminders', 'activity_start', 'birthday_wish', 'birthday_marketing', 'activity_end', 'class_reminder'].indexOf(this.automation_meta.type) >= 0) return true
        if (this.to.to == 'amilia' || this.to.to == 'class_participants') return true
        if (!this.to.list || this.to.to != 'list') return false
        return this.to.list.type == 'upload' ||
          this.to.list.type == 'class_participants' ||
          this.to.list.type.indexOf('amilia') >= 0 ||
          this.to.list.type == 'generic_form' ||
          this.to.list.type == 'payment_form' ||
          this.to.list.type == 'recipients' &&
          !!this.to.list.subset_of_recipient_list_id
      },
      doNotForgetMessage() {
        if (this.use_template || !this.body ||
          !!this.invoice_no || this.attach_invoice ||
          !!this.attach_pdf_recipient_list_id || !!this.ucid)
          return null
        if (!this.use_shorten_url && !this.use_form && !this.share_qr_code && !this.is_referral) {
          let match = this.body.match(new RegExp(trans('form'), 'gi'))
          if (match) return trans('do_not_forget_form')
          match = this.body.match(new RegExp(trans('term_waiver'), 'gi'))
          if (match) return trans('do_not_forget_form')
          match = this.body.match(new RegExp(trans('term_attach'), 'gi'))
          if (match && !this.serialized.media_url) return trans('do_not_forget_attachment')
        }
        return null
      },
      sendingManySmsMessage() {
        if (this.type == 'email') return null
        let count = this.resend_not_opened_count !== null ? this.resend_not_opened_count : this.smsCount
        if (count > 100) return trans('sending_many_sms').replace(':count', count)
        return null
      },
      templateInitialRecipient() {
        if (this.to.to == 'person') return {
          name: null,
          email: this.to.email,
          mobile: this.to.mobile,
        }
        if (this.to.to == 'self') return {
          name: this.user.full_name,
          email: this.user.email,
          mobile: this.user.mobile,
        }
        if (this.to.to == 'people' && this.to.people && this.to.people.length)
          return this.to.people[0]
        return null
      },
      templateInitialListId() {
        return this.to.to == 'list' ||
          this.to.to == 'amilia' ||
          this.to.to == 'combine' ||
          this.to.to == 'class_participants' ?
          this.to.list_id :
          null
      },
      validationErrors() {
        let errors = []
        if (!this.to_custom && this.to.to == 'list' && this.to.list_id == null) errors.push(trans('choose_a_list')+'.')
        if (!this.to_custom && this.to.to == 'amilia' && !this.isAmiliaListValid) errors.push(trans('choose_participants')+'.')
        if (!this.to_custom && this.to.to == 'combine' && !this.isCombineListValid) errors.push(trans('choose_lists')+'.')
        if (!this.to_custom && this.to.to == 'class_participants' && !this.isClassParticipantsListValid) errors.push(trans('choose_classes')+'.')
        if (!this.to_custom && this.to.to == 'users' && (!this.to.user_ids || this.to.user_ids.length == 0))
          errors.push(trans('choose_users')+'.')
        if (!this.subject && (this.type == 'both' || this.type == 'email')) errors.push(trans('please_subject'))
        if (!this.body && this.template_id && this.type == 'email') {
          // For an email, an empty body with a template is allowed!
          //errors.push(trans('please_email_preview'))
        }
        else if (!this.body) errors.push(trans('please_message'))
        if (this.use_shorten_url && !this.isShortenUrlValid) errors.push(trans('please_shorten_url'))
        if (this.use_video_url && !this.isVideoUrlValid) errors.push(trans('please_video_url'))
        if (this.use_media_url && !this.isMediaUrlValid) errors.push(trans('please_media_url'))
        if (this.use_paper && !this.paper_id) errors.push(trans('choose_a_paper'))
        if (this.use_form && !this.isHasFormValid) errors.push(trans('choose_a_form') + '.')
        return errors
      },
      hasErrors() {
        const hasErrors = this.validationErrors.length > 0

        // TODO: This should be triggered after something has changed - not in a computed property!!!
        if (this._hasErrors != hasErrors) this.$emit('has_errors', hasErrors)
        this._hasErrors = hasErrors

        return hasErrors
      },
      isShortenUrlValid() {
        return _.validateUrl((this.shorten_url||'').trim())
      },
      isHasFormValid() {
        return !!this.recipient_form_id
      },
      isVideoUrlValid() {
        return _.validateUrl(this.video_url)
      },
      isMediaUrlValid() {
        return _.validateUrl((this.media_url||'').trim())
      },
      isAmiliaListValid() {
        if (this.to.amilia_list == null || this.to.amilia_list.amilia_live_list == null) return false
        if (this.type == 'email' && this.to.amilia_list.valid_email_count == 0) return false
        if (this.type == 'sms' && this.to.amilia_list.valid_mobile_count == 0) return false
        if (this.to.amilia_list.valid_email_count == 0 && this.to.amilia_list.valid_mobile_count == 0) return false
        return true
      },
      isCombineListValid() {
        if (this.to.combine_list == null) return false
        if (this.type == 'email' && this.to.combine_list.valid_email_count == 0) return false
        if (this.type == 'sms' && this.to.combine_list.valid_mobile_count == 0) return false
        if (this.to.combine_list.valid_email_count == 0 && this.to.combine_list.valid_mobile_count == 0) return false
        return true
      },
      isClassParticipantsListValid() {
        if (this.to.class_participants_list == null) return false
        if (this.type == 'email' && this.to.class_participants_list.valid_email_count == 0) return false
        if (this.type == 'sms' && this.to.class_participants_list.valid_mobile_count == 0) return false
        if (this.to.class_participants_list.valid_email_count == 0 && this.to.class_participants_list.valid_mobile_count == 0) return false
        return true
      },
      oto_template() {
        if (!this.oto_template_id || !this.oto_templates) return null
        return _.find(this.oto_templates, {source_id: this.template_id})
      },
      message() {
        if (!this.body) return `<p><em>${trans('empty_message')}</em></p>`
        let body = _.ckeditorHtmlToText(this.body)
        let message = body.substr(0, 290).replace('\n', '<br/>')
        if (body.length > 290) message += '...'
        if (body.length > 290 ||
          !!this.use_shorten_url ||
          !!this.template_id ||
          (this.use_form && !!this.recipient_form_id) ||
          this.use_video_url && this.isVideoUrlValid ||
          this.use_media_url && this.isMediaUrlValid ||
          this.use_paper && !!this.paper_id ||
          !!this.template_id ||
          this.invoice_is_contract && !!this.ucid ||
          this.attach_invoice) {
          message += '<br/><a href="#" onclick="event.preventDefault()">https://am.lol/xxxxxxx</a>'
        }
        return message
      },
      /*message() {
        let message = _.ckeditorHtmlToText(this.body).substr(0, 290).replace('\n', '<br/>')
        if (this.use_shorten_url || this.template_id || (this.use_form && this.recipient_form_id))
          message += '<br/><a href="#" onclick="event.preventDefault()">https://am.lol/xxxxxxx</a>'
        if (this.use_video_url && this.isVideoUrlValid) {
          message = message + `<br/><a href="#" onclick="event.preventDefault()">${this.gated_vimeo_url ? this.gated_vimeo_url.url : this.video_url}</a>`
          if (this.video_thumbnail_url)
            message = `<img src="${this.video_thumbnail_url}" style="max-width:100%;" /><br/>` + message
          else if (this.video_thumbnail_busy)
            message = '<p class="text-center"><i class="fa fa-fw fa-circle-notch fa-spin"></i> ' + trans('loading') + '</p>' + message
        }
        if (this.use_media_url && this.isMediaUrlValid)
          message = `<img src="${this.media_url}" style="max-width:100%;" /><br/>` + message
        if (this.template_id && this.template_image_url)
          message = `<img src="${this.template_image_url}" style="max-width:100%;" /><br/>` + message
        if (!message) message = `<p><em>${trans('empty_message')}</em></p>`
        return message
      },*/
      smsCount() {
        if (this.to_custom) return this.to_custom.sms_count
        if (this.type == 'email') return 0
        if (this.to.to == 'person' || this.to.to == 'self') return 1
        if (this.to.to == 'people')
          return _.reduce(this.to.people || [], (count, o) => {
            if (o.mobile) count += 1
            return count
          }, 0)
        if (this.to.to == 'list' && this.to.list) return this.to.list.valid_mobile_count
        if (this.to.to == 'amilia' && this.to.amilia_list && this.to.amilia_list.valid_mobile_count > 0)
          return this.to.amilia_list.valid_mobile_count
        if (this.to.to == 'combine' && this.to.combine_list && this.to.combine_list.valid_mobile_count > 0)
          return this.to.combine_list.valid_mobile_count
        if (this.to.to == 'class_participants' && this.to.class_participants_list && this.to.class_participants_list.valid_mobile_count > 0)
          return this.to.class_participants_list.valid_mobile_count
        return 0
      },
      emailCount() {
        if (this.to_custom) return this.to_custom.email_count
        if (this.type == 'sms') return 0
        if (this.to.to == 'person' || this.to.to == 'self') return 1
        if (this.to.to == 'people')
          return _.reduce(this.to.people || [], (count, o) => {
            if (o.email) count += 1
            return count
          }, 0)
        if (this.to.to == 'list' && this.to.list) return this.to.list.valid_email_count
        if (this.to.to == 'amilia' && this.to.amilia_list && this.to.amilia_list.valid_email_count > 0)
          return this.to.amilia_list.valid_email_count
        if (this.to.to == 'combine' && this.to.combine_list && this.to.combine_list.valid_email_count > 0)
          return this.to.combine_list.valid_email_count
        if (this.to.to == 'class_participants' && this.to.class_participants_list && this.to.class_participants_list.valid_email_count > 0)
          return this.to.class_participants_list.valid_email_count
        return 0
      },
      emailPreviewMarginY() {
        return this.emailPreviewFullWidth * 0.30
      },
      emailPreviewMarginX() {
        return this.emailPreviewFullWidth * 0.020
      },
      emailPreviewWidth() {
        return this.emailPreviewFullWidth - this.emailPreviewMarginX * 2
      },
      emailPreviewHeight() {
        return this.emailPreviewFullWidth
      },
      emailPreviewScale() {
        return this.emailPreviewWidth / 360
      },
      recipient_filter() {
        let f = this.initial_recipient_filter || null

        if (!f && this.only_send_not_filled && this.recipient_form_id) f = {type: 'filled'}
        if (f && f.type == 'filled') {
          f = this.only_send_not_filled ?
            {
              recipient_list_id: this.recipient_form_id,
              csv_activity: this.to.csv_activity,
              form_custom_value: this.to.form_custom_value,
              other_recipient_form_id: this.initial_recipient_filter ? this.initial_recipient_filter.other_recipient_form_id : null,
              type: 'filled',
              from: this.initial_recipient_filter ? this.initial_recipient_filter.from : null,
              to: this.initial_recipient_filter ? this.initial_recipient_filter.to : null,
            } : null
        }

        // Nothing to do for type not_opened

        if (this.to.csv_activity && !f) {
          f = {
            csv_activity: this.to.csv_activity,
            type: 'csv_activity'
          }
        }

        if (this.to.form_custom_value && !f) {
          f = {
            form_custom_value: this.to.form_custom_value,
            type: 'form_custom_value'
          }
        }

        return f
      },
      only_send_not_filled_label() {
        if (this.recipient_filter && this.recipient_filter.type == 'filled' && this.recipient_filter.from) {
          return trans('only_send_not_filled_date_range')
            .replace(':from', moment(this.recipient_filter.from, 'YYYY-MM-DD').format('LL'))
            .replace(':to', moment(this.recipient_filter.to, 'YYYY-MM-DD').format('LL'))
        }
        return trans('only_send_not_filled')
      },
      emptyListWarning() {
        if (this.to_custom) return null
        if (this.to.to == 'list' && this.to.list ||
          this.to.to == 'amilia' && this.to.amilia_list ||
          this.to.to == 'combine' && this.to.combine_list ||
          this.to.to == 'class_participants' && this.to.class_participants_list) {
          if (this.emailCount == 0 && this.smsCount == 0) {
            return trans('send_warning_list_no_recipients')
          }
          if (this.type != 'sms' && this.emailCount == 0) {
            return trans('send_warning_list_no_emails')
          }
          if (this.type != 'email' && this.smsCount == 0) {
            return trans('send_warning_list_no_mobile')
          }
        }
        return null
      },
      showAllowDups() {
        return this.to &&
          this.to.to == 'list' &&
          this.to.list &&
          (this.to.list.type == 'upload' || this.to.list.subtype == 'marketing')
      },
      serialized() {
        return this.serializeOptions()
      },
      canClickPreview() {
        return !this.isSaving &&
          !this.hasErrors &&
          (!!this.emailPreviewUrl || this.type == 'sms') &&
          this.to &&
          this.to.to != 'people' &&
          this.to.to != 'users' &&
          !(!!this.to.list && this.to.list.type == 'master')
      },
      groupedMessages() {
        if (!this.thread_messages) return []
        return _.groupThreadMessages(this.thread_messages)
      },
    },
    watch: {
      initial_subject() {
        this.subject = this.initial_subject || trans('message_from').replace(':org', this.organization.name)
      },
      initial_body() {
        this.temp_initial_body = this.initial_body || `<p>${this.organization.alias}</p>`
      },
      type() {
        if (this.type != 'both') this.preview = this.type
      },
      from_email() {
        if (this.organization.verified_from_emails.indexOf(this.from_email) >= 0 ||
          this.user.email == this.from_email) {
          this.reply_to.email = this.from_email
        }
      },
      preview() {
        if (this.preview == 'sms') {
          this.emailPreviewUrl = null
          this.emailPreviewEmpty = true
          this.emailPreviewError = null
        } else {
          this.maybeRefreshEmailPreview(true)
        }
      },
      body() {
        this.maybeRefreshEmailPreview()
      },
      shorten_url() {
        if (this.use_shorten_url && this.document && this.document.short_url != this.shorten_url)
          this.document = null
        this.maybeRefreshEmailPreview()
      },
      media_url() {
        this.maybeRefreshEmailPreview()
      },
      paper_id() {
        this.maybeRefreshEmailPreview()
      },
      use_paper() {
        this.maybeRefreshEmailPreview()
      },
      use_video_url() {
        this.maybeRefreshEmailPreview()
      },
      use_media_url() {
        this.maybeRefreshEmailPreview()
      },
      use_shorten_url() {
        if (this.use_shorten_url)
          this.shorten_button_text = this.document ? this.document.name : this.initial_use_url_cta || null
        this.maybeRefreshEmailPreview()
      },
      use_form() {
        if (this.use_form)
          this.shorten_button_text = this.recipient_form ? this.recipient_form.name : this.initial_use_url_cta || null
        this.maybeRefreshEmailPreview()
      },
      shorten_button_text() {
        this.maybeRefreshEmailPreview()
      },
      recipient_form_id() {
        this.maybeRefreshEmailPreview()
        if (this.recipient_form_id) this.comtype = 'reminders'
        if (this.recipient_filter) this.recipient_filter.recipient_list_id = this.recipient_form_id
      },
      template_id() {
        this.maybeRefreshEmailPreview()
      },
      video_thumbnail_url() {
        this.maybeRefreshEmailPreview()
      },
      recipient_list_id() {
        this.$set(this.to, 'list_id', this.recipient_list_id)
        this.$set(this.to, 'to', this.recipient_list_id ? 'list' : 'self')
      },
      attach_pdf_recipient_list_id() {
        if (this.attach_pdf_recipient_list_id) {
          this.attach_pdf_tickets = false
        }
      },
      attach_invoice() {
        if (this.attach_invoice) {
          this.attach_pdf_tickets = false
        }
      }
    },
    methods: {
      onClickPreview() {
        this.getEmailPreviewUrl(true)
        .then(() => {
          this.$bvModal.show('message-preview-modal')
        })
      },
      onRecipientForm(recipient_form, options) {
        this.recipient_form = recipient_form
        if (!options || options.source != 'fetch' ||
          this.initial_use != 'form' || this.initial_use_url_cta != this.shorten_button_text) {
          this.shorten_button_text = recipient_form.name
        }
      },
      onDocument(doc, options) {
        this.document = doc
        if (!options || options.source != 'fetch' ||
          this.initial_use != 'shorten_url' || this.initial_use_url_cta != this.shorten_button_text) {
          this.shorten_button_text = doc.name
        }
      },
      onPage(page) {
        this.shorten_button_text = page.name
      },
      prefillInitialBody() {
        if (this.temp_initial_body) {
          this.body = this.temp_initial_body
          this.temp_initial_body = undefined
        }
      },
      onClickCC() {
        if (!this.show_cc) this.show_cc = true
        else if (!this.cc_user_ids || this.cc_user_ids.length == 0) this.show_cc = false
      },
      maybeRefreshEmailPreview(force) {
        if (this.preview == 'email') this.getEmailPreviewUrl(force)
        if (this.preview == 'sms') {
          this.$nextTick(() => {
            this.$refs.chat.scrollTop = this.$refs.chat.scrollHeight
          })
        }
      },
      onToggleOtoTemplate() {
        this.edit_oto_template = !this.edit_oto_template;
        if (this.edit_oto_template) this.maybeLoadOtoTemplate()
      },
      onClickUseTemplate() {
        this.use_template = !this.use_template;
        if (this.use_template) {
          this.use_media_url = this.use_video_url = this.use_paper = false
          if (this.last_selected_template_id) {
            this.template_id = this.last_selected_template_id
          }
        } else {
          this.template_id = null
        }
      },
      updateSubject(subject) {
        this.subject = subject || ''
        if (this.template_id) this.body = `<p>${subject||''}<p/>`
      },
      onChangeTemplate(loaded) {
        if (this.template_id == null) return

        this.last_selected_template_id = this.template_id

        // Hack to force subject/comtype/from_email change after loading the first time
        if (!this.onChangeTemplateFirstTime && loaded) {
          this.onChangeTemplateFirstTime = true
          loaded = false
          if (!this.initial_from_email && !!this.$refs.template.selected.from_email) {
            this.from_email = this.$refs.template.selected.from_email
          }
          if (!this.initial_from_name && !!this.$refs.template.selected.from_name) {
            this.from_name = this.$refs.template.selected.from_name
          }
        } else {
          if (!!this.$refs.template.selected.subject && !this.$refs.template.selected.is_oto)
            this.updateSubject(this.$refs.template.selected.subject)
          this.comtype = this.$refs.template.selected.comtype
          if (!!this.$refs.template.selected.from_email) {
            this.from_email = this.$refs.template.selected.from_email
          }
          if (!!this.$refs.template.selected.from_name) {
            this.from_name = this.$refs.template.selected.from_name
          }
        }

        this.maybeLoadOtoTemplate()
      },
      maybeLoadOtoTemplate() {
        if (this.edit_oto_template) {
          let oto_template = _.find(this.oto_templates, {source_id: this.template_id})
          if (!oto_template) {
            let url = `/organization/${this.organization.id}/sendout/oto_template/${this.template_id}`
            this.templates_busy = true
            axios.post(url)
            .then(response => {
              this.templates_busy = false
              this.oto_templates.push(response.data)
              this.oto_template_id = response.data.id
            })
            .catch(error => {
              this.templates_busy = false
              this.error = _.errorFromAjax(error)
            })
          }
        }
      },
      loadTemplateImages() {
        return
        if (this.template_image_cache[this.template_id]) {
          this.template_image_urls = this.template_image_cache[this.template_id]
          if (this.template_image_urls.indexOf(this.template_image_url) == -1)
            this.template_image_url = null
          return
        }
        let url = `/organization/${this.organization.id}/sendout/template/${this.template_id}/image_urls`
        this.templates_busy = true
        this.template_image_urls = []
        this.template_image_url = null
        axios.get(url)
        .then(response => {
          this.templates_busy = false
          this.template_image_urls = this.template_image_cache[this.template_id] = _.uniq(response.data)
        })
        .catch(error => {
          this.templates_busy = false
          this.error = _.errorFromAjax(error)
        })
      },
      serializeOptions() {
        return {
          type: this.type,
          from_email: this.from_email,
          from_name: this.from_name,
          reply_to_mobile_preference: this.reply_to.mobile_preference,
          reply_to_mobile: this.reply_to.mobile,
          reply_to_email: this.reply_to.email,
          recipient_list_id: this.to.to == 'list' ? this.to.list_id : (this.to.to == 'amilia' && this.to.amilia_list ? this.to.amilia_list.id : (this.to.to == 'combine' && this.to.combine_list ? this.to.combine_list.id : (this.to.to == 'class_participants' && this.to.class_participants_list ? this.to.class_participants_list.id : null))),
          to_mobile: _.formatPhone(this.to.to == 'self' ? this.user.mobile : (this.to.to == 'person' ? this.to.to_mobile : null)),
          to_email: this.to.to == 'self' ? this.user.email : (this.to.to == 'person' ? this.to.to_email : null),
          to_name: this.to.to == 'self' ? this.user.name : this.person_name || null,
          people: this.to.to == 'people' ? this.to.people : null,
          cc_user_ids: this.cc_user_ids,
          user_ids: this.to.to == 'users' ? this.to.user_ids : null,
          message_both_parents: this.showMessageBothParents ? this.message_both_parents : false,
          subject: typeof this.subject == 'string' ? this.subject.trim() : this.subject,
          body: this.body,
          shorten_url: this.use_shorten_url ? (this.shorten_url||'').trim() :
            (this.use_form && this.recipient_form != null ? this.recipient_form.page_url : null),
          shorten_button_text: this.use_shorten_url || this.use_form ? this.shorten_button_text : null,
          media_url: this.use_template && this.template_id ?
            this.template_image_url :
            (this.use_video_url && this.video_thumbnail_url ?
              this.video_thumbnail_url :
              (this.use_media_url ?
                (this.media_url||'').trim() :
                  (this.use_paper && this.paper && this.paper.preview_media ? this.paper.preview_media.url : null))),
          media_cta_url: this.use_video_url ? (this.gated_vimeo_url ? this.gated_vimeo_url.url : this.video_url) : null,
          template_id: this.template_id,
          oto_template_id: this.oto_template_id,
          recipient_form_id: this.use_form ? this.recipient_form_id : null,
          recipient_filter: this.recipient_filter,
          invoice_no: this.invoice_no,
          attach_invoice: this.attach_invoice,
          attach_pdf_tickets: this.attach_pdf_tickets,
          ucid: this.use_shorten_url || this.invoice_is_contract ? this.ucid : null,
          invoice_is_contract: this.invoice_is_contract || false,
          amilia_event_id: this.amilia_event_id || null,
          booking_id: this.booking_id || null,
          scheduled_at: null,
          automation_id: this.automation_id || null,
          automation_meta: this.automation_meta || null,
          comtype: this.comtype,
          is_referral: this.is_referral,
          subset_of_recipient_list_id: this.subset_of_recipient_list_id || null,
          allow_dups: this.allow_dups,
          context: this.context,
          paper_id: !!this.paper ? this.paper.id : null,
          attach_pdf_recipient_list_id: this.attach_pdf_recipient_list_id,
          rl24_id: !!this.rl24 ? this.rl24.id : null,
          force_lang: this.force_lang || null,
          thread_twilio_message_id: this.thread_twilio_message_id || null,
        }
      },
      onClickCancel() {
        this.$emit('cancel')
        if (this.noRedirect) return
        window.location = this.return_url || `/organization/${this.organization.id}/sendout?success`
      },
      onClickSubmit() {
        let url = `/organization/${this.organization.id}/sendout`
        let options = this.serializeOptions()
        if (this.options) url += '/' + this.options.id;
        let method = this.options ? 'patch' : 'post'

        this.status = trans('sending')
        this.isError = false
        this.isSaving = true

        axios[method](url, options)
        .then(response => {
          this.options = response.data
          this.status = trans('please_wait')
          this.$emit('sent', response.data)
          if (this.noRedirect) return
          setTimeout(() => {
            window.location = this.return_url || `/organization/${organization.id}/sendout`
          }, 1000)
        })
        .catch(error => {
          this.isSaving = false
          this.isError = true
          this.status = _.errorFromAjax(error)
          this.$emit('error', this.status)
        })
      },
      getEmailPreviewUrl(force) {
        if (this.emailPreviewBusy) {
          this.emailPreviewLoadWhenIdle = true
          return new Promise((resolve, reject) => {
            resolve()
          })
        }

        let url = '/organization/' + this.organization.id + '/sendout/prepare_email_preview'
        let options = this.serializeOptions()
        options.to_mobile = '555-123-1234'
        options.to_name = 'John Doe'
        options.to_email = 'john@doe.com'
        options.body || (options.body = `<p><em>${trans('empty_message')}</em></p>`)
        options.shorten_url = options.shorten_url || options.recipient_form_id ? 'https://am.lol/abc1234' : null
        options.automation_id = null
        options.automation_meta = null
        options.subject || (options.subject = 'hello')

        let str = JSON.stringify(options)
        if (force !== true &&
          this.emailPreviewLastOptions &&
          this.emailPreviewLastOptions == str ||
          this.emailPreviewLoadWhenIdle) {
            return new Promise((resolve, reject) => {
              resolve()
            })
        }

        this.emailPreviewLastOptions = str
        this.emailPreviewError = null
        this.emailPreviewBusy = true

        return axios.post(url, options)
        .then(response => {
          if (!this.emailPreviewUrl || !this.$refs.iframe) {
            // First time, load the iframe
            this.emailPreviewUrl = response.data.url
          } else {
            // Other times, tell it to load fresh content
            this.emailPreviewUrl = response.data.url
            this.$refs.iframe.contentWindow.postMessage({url: this.emailPreviewUrl}, window.location.origin)
          }
          if (!this.emailPreviewFullWidth) this.handleResize()
        })
        .catch(error => {
          this.emailPreviewBusy = false
          this.emailPreviewUrl = null
          this.emailPreviewError = _.errorFromAjax(error)
        })
      },
      onIframeLoaded() {
        this.emailPreviewBusy = false
        this.emailPreviewEmpty = false
        if (this.emailPreviewLoadWhenIdle) {
          this.emailPreviewLoadWhenIdle = false
          this.$nextTick(this.getEmailPreviewUrl)
        }
      },
      handleScroll() {
        let $preview = $('#preview')
        let $parent = $preview.parent()
        let $img = $preview.find('img')

        let t = Math.max(0, window.scrollY - $parent.offset().top + 10)
        t -= Math.max(0, t + $img.outerHeight() - $parent.outerHeight())
        if (t < 0 ) t = 0

        $preview.css('margin-top', t + 'px')
      },
      handleResize() {
        if (this.$refs.preview) {
          this.emailPreviewFullWidth = this.$refs.preview.clientWidth
        }
      },
      onAiInput(e){
        this.body += e
      },
      fetchThreadMessages() {
        if (!this.thread_twilio_message_id) return
        this.isError = false
        this.status = null
        this.thread_messages = null
        let url = `/organization/${this.organization.id}/sendout/sms/${this.thread_twilio_message_id}/thread`
        axios.get(url)
        .then(response => {
          this.busy = false
          this.thread_messages = response.data
        })
        .catch(error => {
          this.isError = true
          this.status = _.errorFromAjax(error)
          this.$emit('error', this.status)
        })
      },
    },
    mounted() {
      window.sendOutComponent = this
      this.getEmailPreviewUrl = _.debounce(this.getEmailPreviewUrl, 250)
      this.handleResize()
      setTimeout(this.maybeRefreshEmailPreview, 1000)
      if (!!this.thread_twilio_message_id) this.fetchThreadMessages()
    },
    created () {
      window.addEventListener('scroll', this.handleScroll)
      window.addEventListener('resize', this.handleResize)
      window.addEventListener('message', this.onIframeLoaded)
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll)
      window.removeEventListener('resize', this.handleResize)
      window.removeEventListener('message', this.onIframeLoaded)
    },
  }
</script>
